
import { Vue, Component } from 'vue-property-decorator';

@Component({ name: 'LiveChip' })
export default class LiveChip extends Vue {}
